'use strict';

var React = require('react');

var SvgBuyButtonButtonLayoutMajor = function SvgBuyButtonButtonLayoutMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.5 5.25c0-.966.784-1.75 1.75-1.75h1a.75.75 0 0 1 0 1.5h-1a.25.25 0 0 0-.25.25v1a.75.75 0 0 1-1.5 0v-1Zm1.75 11.25a1.75 1.75 0 0 1-1.75-1.75v-1a.75.75 0 0 1 1.5 0v1c0 .138.112.25.25.25h1a.75.75 0 0 1 0 1.5h-1Zm11.25-11.25a1.75 1.75 0 0 0-1.75-1.75h-1a.75.75 0 0 0 0 1.5h1a.25.25 0 0 1 .25.25v1a.75.75 0 0 0 1.5 0v-1Zm0 9.5a1.75 1.75 0 0 1-1.75 1.75h-1a.75.75 0 0 1 0-1.5h1a.25.25 0 0 0 .25-.25v-1a.75.75 0 0 1 1.5 0v1Zm-5.5-9.75a.75.75 0 0 0 0-1.5h-2a.75.75 0 0 0 0 1.5h2Zm.75 10.75a.75.75 0 0 1-.75.75h-2a.75.75 0 0 1 0-1.5h2a.75.75 0 0 1 .75.75Zm-5.75-8.25a2.5 2.5 0 0 0 0 5h8a2.5 2.5 0 0 0 0-5h-8Zm-1 2.5a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2h-8a1 1 0 0 1-1-1Z"
  }));
};
SvgBuyButtonButtonLayoutMajor.displayName = "BuyButtonButtonLayoutMajor";

exports.SvgBuyButtonButtonLayoutMajor = SvgBuyButtonButtonLayoutMajor;
